var map = {
	"./ais-point": "f282",
	"./ais-point.js": "f282",
	"./article": "f24e",
	"./article.js": "f24e",
	"./banner": "cc94",
	"./banner.js": "cc94",
	"./data-management": "d6e2",
	"./data-management.js": "d6e2",
	"./document": "5484",
	"./document.js": "5484",
	"./flashdeal": "04e5",
	"./flashdeal.js": "04e5",
	"./fulfillment": "29e5",
	"./fulfillment.js": "29e5",
	"./inventory": "d7eb",
	"./inventory.js": "d7eb",
	"./lucky-draw": "086d",
	"./lucky-draw.js": "086d",
	"./lucky-winner": "8dc0",
	"./lucky-winner.js": "8dc0",
	"./pdpa": "c5fe",
	"./pdpa.js": "c5fe",
	"./point-exchange": "33db",
	"./point-exchange.js": "33db",
	"./privileges": "460e",
	"./privileges.js": "460e",
	"./product": "d062",
	"./product.js": "d062",
	"./report": "07d1",
	"./report.js": "07d1",
	"./survey": "c6af",
	"./survey.js": "c6af",
	"./tags": "768d",
	"./tags.js": "768d",
	"./test": "6cc1",
	"./test.js": "6cc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d564";